import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISourceRegistryResponseModel } from '../../../models';
import { CreateSourceRegistryState } from '../../actions/types/sources/CreateSourceRegistryTypes';

/**
 * Initial Event state in store
 */
const initialState: CreateSourceRegistryState = {
  success: false,
  isLoading: false,
  errorMessage: '',
  sourceRegistryData: null,
  statusCode: ''
};

/**
 * Create Event Slice to create new Event
 */
const createSourceRegistrySlice = createSlice({
  name: 'createSourceRegistry',
  initialState,
  reducers: {
    createSourceRegistryStarted: (state) => {
      state.isLoading = true;
    },

    createSourceRegistrySuccess: (state, action: PayloadAction<ISourceRegistryResponseModel[]>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.sourceRegistryData = action.payload;
    },

    createSourceRegistryFail: (state, action: PayloadAction<{ errorCode: string, errorMessage: string, timestamp: string }>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload.errorMessage;
      state.sourceRegistryData = initialState.sourceRegistryData;
      state.statusCode = action.payload.errorCode;
    },

    clearSourceRegistry: (state,) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.sourceRegistryData = initialState.sourceRegistryData;
    }
  }
});

export const { createSourceRegistryStarted, createSourceRegistrySuccess, createSourceRegistryFail, clearSourceRegistry } = createSourceRegistrySlice.actions;
export default createSourceRegistrySlice.reducer;
